"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.CONTACT],
  objectType: _ObjectTypes.CONTACT,
  recordName: 'ContactRecord',
  defaults: {
    'associated-company': undefined,
    'canonical-vid': null,
    deleted: false,
    'form-submissions': (0, _immutable.List)(),
    'identity-profiles': (0, _immutable.List)(),
    'is-contact': true,
    'list-memberships': (0, _immutable.List)(),
    'merge-audits': (0, _immutable.List)(),
    'merged-vids': (0, _immutable.List)(),
    'portal-id': null,
    'profile-token': null,
    'profile-url': null,
    properties: (0, _immutable.Map)(),
    vid: null
  }
}, {
  primary: ['firstname', 'lastname'],
  secondary: ['email']
});

exports.default = _default;
module.exports = exports.default;